import { memo } from 'react';
import { IconProps } from './iconType';

export const CloseIcon = memo(({ size, color }: IconProps) => {
  return (
    // export된 svg가 있다면 => 코드창에 열어서 있는 코드 아래 형식처럼 수정하기
    // 디자인 파일에서 svg가 있다면 => svg 코드 복사해서 아래 형식처럼 수정하기
    // xmlns 속성은 제거
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path
        d="M19.1474 18.3525C19.2027 18.404 19.247 18.4661 19.2777 18.5351C19.3085 18.6041 19.325 18.6786 19.3263 18.7541C19.3277 18.8296 19.3138 18.9047 19.2855 18.9747C19.2572 19.0447 19.2151 19.1084 19.1617 19.1618C19.1082 19.2152 19.0446 19.2573 18.9746 19.2856C18.9045 19.3139 18.8295 19.3278 18.754 19.3265C18.6785 19.3251 18.604 19.3086 18.535 19.2778C18.466 19.2471 18.4039 19.2028 18.3524 19.1475L11.9999 12.7959L5.64739 19.1475C5.54075 19.2469 5.39972 19.301 5.25399 19.2984C5.10827 19.2958 4.96923 19.2368 4.86617 19.1337C4.76311 19.0307 4.70407 18.8916 4.7015 18.7459C4.69893 18.6002 4.75302 18.4591 4.85238 18.3525L11.2039 12L4.85238 5.64751C4.75302 5.54088 4.69893 5.39984 4.7015 5.25411C4.70407 5.10839 4.76311 4.96935 4.86617 4.86629C4.96923 4.76323 5.10827 4.7042 5.25399 4.70163C5.39972 4.69905 5.54075 4.75315 5.64739 4.85251L11.9999 11.2041L18.3524 4.85251C18.459 4.75315 18.6001 4.69905 18.7458 4.70163C18.8915 4.7042 19.0305 4.76323 19.1336 4.86629C19.2367 4.96935 19.2957 5.10839 19.2983 5.25411C19.3008 5.39984 19.2467 5.54088 19.1474 5.64751L12.7958 12L19.1474 18.3525Z"
        fill={color}
      />
    </svg>
  );
});

CloseIcon.displayName = 'CloseIcon';
